export const VESSEL_NAME = "RV OceanXplorer";
export const ROV_NAME = "Argus ROV Chimera";
export const DROPDOWN_PRELOAD_SIZE = 500;
